module.exports = __webpack_public_path__ + "img/school-bag.007baed3.png";